export default function appendSpotlightTracking($spotLightCarousel, trackingObj = {}) {
    if ($spotLightCarousel.length) {
        let $spotlightLink = $spotLightCarousel.find('.spotlight-link');
        let aaLinkData = $spotlightLink.attr('aa-link').split('|');
        if (aaLinkData) {
            let spotlightTrackingObj = {
                carouselPresentationStyle: 'spotlight',
                clientTimestamp: Date.now(),
                videoId: aaLinkData[25] ?? '',
                videoPreviewId: aaLinkData[18] ?? '',
                streamStartTimestamp: aaLinkData[26] ?? '',
                streamEndTimestamp: aaLinkData[27] ?? '',
                contentStatus: aaLinkData[29] ?? '',
                rowHeaderTitle: aaLinkData[4] ?? '',
                spliceEnabled: '0',
                ctaText: $spotLightCarousel
                    .find('.swiper-slide-visible .spotlight-button:visible .button__text')
                    .text(),
                carouselId: $spotLightCarousel.data('carouselid') ?? trackingObj.carouselId ?? '',
                isHighlightEnabled: 'false',
                carouselContentType: aaLinkData[30] ?? '',
                carouselLink: $spotlightLink.attr('href') ?? '',
                posRowNum: $spotLightCarousel.data('position') ?? '',
                showSeriesId: aaLinkData[6] ?? '',
                showSeriesTitle: aaLinkData[14] ?? '',
                showEpisodeTitle: aaLinkData[5] ?? '',
                showEpisodeId: aaLinkData[20] ?? '',
                showSeasonNumber: aaLinkData[7] ?? '',
                showGenre: aaLinkData[30] !== 'movie' ? aaLinkData[15] : '',
                contentBrand: aaLinkData[10] ? aaLinkData[10] : 'na',
                movieId: aaLinkData[30] == 'movie' ? aaLinkData[16] : '',
                movieTitle: aaLinkData[30] == 'movie' ? aaLinkData[0] : '',
                movieGenre: aaLinkData[30] == 'movie' ? aaLinkData[15] : '',
                contentLocked: aaLinkData[23] ?? '',
                carouselModel: $spotLightCarousel.data('model') ?? trackingObj.carouselModel,
            };
            trackingObj = { ...trackingObj, ...spotlightTrackingObj };
            return trackingObj;
        }
    }
}
